// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDirectSMSModalAction,
  sendSmsAction,
} from "../../store/actions/sms/sms";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMemo } from "react";
import { alertDialogAciton } from "../../store/actions/auth";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { CustomTextFiled } from "../Custom/Input";

const style = {
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  width: "500px",
  maxHeight: "90vh",
  // minWidth: "300px",
  maxWidth: "1000px",
  overflowY: "auto",
  transition: "all 0.3s ease",
  "@media (max-width: 600px)": {
    maxHeight: "97vh",
    maxWidth: "95vh",
  },
};

export const DirectSMSModal = ({}) => {
  const { directSmsModalStatus, directSmsModalData, isLoading } = useSelector(
    (state) => state?.smsReducer,
  );

  const allNames = useMemo(() => {
    return directSmsModalData?.map((item) => item?.name)?.join(", ");
  }, [directSmsModalData]);

  const allIds = useMemo(() => {
    return directSmsModalData?.map((item) => item?._id);
  }, [directSmsModalData]);

  const dispatch = useDispatch();

  function onClose() {
    dispatch(closeDirectSMSModalAction());
  }

  const initialState = {
    message: "",
    name: "",
  };

  const validationSchema = Yup.object().shape({
    message: Yup.string()
      .trim()
      .required("Message is required!")
      .max(300, "Message can be of at max 300 characters!"),
    name: Yup.string(),
  });

  const formik = useFormik({
    initialValues: initialState,
    validationSchema,
    onSubmit: (values) => {
      const userIds = allIds?.map((id) => ({
        id,
      }));

      dispatch(
        sendSmsAction({
          payload: {
            data: {
              userIds,
              content: values?.message,
            },
          },
          successCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: msg || "SMS sent successfully",
              }),
            );
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Failure",
                message: msg || "Failed to send SMS",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    errors,
    touched,
    setValues,
    submitForm,
    handleBlur,
    handleChange,
  } = formik;

  return (
    <Modal
      open={directSmsModalStatus}
      onClose={onClose}
      sx={{
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          ...style,
          display: "flex",
          justifyContent: "flex-start",
          aliginItems: "flex-start",
          gap: "1rem",
          flexDirection: "column",
          overflowY: "visible",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.25rem",
              paddingBottom: "1rem",
              fontWeight: "500",
            }}
          >
            Send Text Message
          </Typography>
        </Box>

        <Grid container>
          <Grid item xs={12}>
            <Typography
              sx={{
                "& p": {
                  display: "inline-flex",
                },
              }}
            >
              <Typography
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
              >
                Contactor Name:
              </Typography>{" "}
              <Typography>{allNames}</Typography>
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <CustomTextFiled
              name={"message"}
              value={values?.message}
              onBlur={handleBlur}
              onChange={handleChange}
              multiline
              fullWidth
              rows={3}
              placeholder={"message here"}
            />
            {touched?.message && errors?.message && (
              <Typography color="red">{errors?.message}</Typography>
            )}
          </Grid>
        </Grid>

        <Box
          className="bottom-btn-box"
          sx={{
            width: "100%",
            marginTop: "2rem",
            alignSelf: "flex-end",
            marginBottom: " 2rem",
          }}
        >
          <Button
            className="btn-black"
            sx={{
              width: "50%",
              height: "3.25rem",
              textTransform: "none !important",
            }}
            onClick={onClose}
          >
            <Typography className="btn-text">Close</Typography>
          </Button>

          <Button
            className="btn-pink"
            sx={{
              width: "50%",
              height: "3.25rem",
              textTransform: "none !important",
              "&:disabled": {
                background: "#d85ad8 !important",
              },
            }}
            onClick={submitForm}
          >
            {isLoading ? (
              <CircularProgress size={22} />
            ) : (
              <Typography sx={{ whiteSpace: "nowrap" }} className="btn-text">
                Send
              </Typography>
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};